// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"PesticideBy_sideBar__2-ZGR","spinner":"PesticideBy_spinner__juYyo","categoryGroup":"PesticideBy_categoryGroup__2GHmJ"};